'use client'

import { QUERY_ROUTES } from '@/core/constants/routes'
import { useDeleteSearchParam } from '@/core/hooks/use-delete-search-params'
import { Modal, ModalBody } from '@/core/ui/atoms/modal'
import { CreateAccountForm } from '@/features/auth/ui/create-account/create-account'
import { useCallback } from 'react'

export const CreateAccountModal = () => {
  const { searchParams, deleteSearchParam } = useDeleteSearchParam()

  const handleClose = useCallback(() => {
    deleteSearchParam(QUERY_ROUTES.register.name, { clientOnly: true })
  }, [deleteSearchParam])

  return (
    <>
      <Modal
        isOpen={
          QUERY_ROUTES.register.value ===
          searchParams.get(QUERY_ROUTES.register.name)
        }
        onClose={handleClose}
        disableBackdropDismiss
        size='lg'
        className='max-h-[90%] max-w-lg overflow-y-hidden rounded-2xl sm:max-h-[95%]'
      >
        <ModalBody className='p-4'>
          <CreateAccountForm onSuccess={handleClose} />
        </ModalBody>
      </Modal>
    </>
  )
}
